import { useEffect, useState } from 'preact/hooks';
import { api, ApiError } from '../lib/api.js';
import { navigate } from '../lib/router.js';

export function GuestPage({ token }: { token: string }) {
  const [error, setError] = useState('');

  useEffect(() => {
    void api('/api/guest/claim', { method: 'POST', body: { token } })
      .then(() => navigate('/'))
      .catch((e) => setError(e instanceof ApiError ? e.message : 'Ошибка сети'));
  }, [token]);

  return (
    <main class="shell authView">
      <div class="authPanel">
        <p class="eyebrow">Гостевая ссылка</p>
        <h1>Besedka</h1>
        {error ? <p class="notice">{error}</p> : <p>Входим…</p>}
      </div>
    </main>
  );
}
